module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-canned-219715bd27aef4ec77561dc41fd7159f.svg";